import { useCallback, useEffect } from 'react';
import { useActions } from '@app/external/common/components/runtime-context';

export const useAnalyticsPostViewEffect = (postTitle: string | undefined) => {
  const { trackEvent } = useActions();

  const reportPostViewForAnalytics = useCallback(() => {
    if (!postTitle) {
      return;
    }

    trackEvent('BlogPostView', {
      event: 'BlogPostView',
      eventCategory: 'Wix Blog',
      eventAction: 'BlogPostView',
      eventLabel: postTitle,
      origin: 'Wix Blog',
    });
  }, [postTitle, trackEvent]);

  useEffect(() => {
    reportPostViewForAnalytics();
  }, [reportPostViewForAnalytics]);
};
